module.exports = __webpack_public_path__ + "assets/ee9a9b335cae8e42b7c52d0034cce569.png";